import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * Sets a canonical <link> so crawlers treat tracking-param URL variants
 * (utm_*, gclid, brand, retrieve, etc.) as one page rather than duplicates.
 */
@Injectable({ providedIn: 'root' })
export class SeoService {
	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	public updateCanonicalUrl(url: string): void {
		const canonicalUrl = this.buildCanonicalUrl(url);

		let link: HTMLLinkElement | null = this.document.head.querySelector(
			`link[rel='canonical']`
		);

		if (!link) {
			link = this.document.createElement('link');
			link.setAttribute('rel', 'canonical');
			this.document.head.appendChild(link);
		}

		link.setAttribute('href', canonicalUrl);
	}

	private buildCanonicalUrl(url: string): string {
		const path = url.split('?')[0].split('#')[0];

		return `${this.document.location.origin}${path}`;
	}
}
